<script lang="ts">
    export let inputLabel, inputValue, inputName, testId, cssClass;
    function handleInput(e) {
        inputValue = e.target.value;
    }
</script>

<auro-input
    value={inputValue}
    on:input={handleInput}
    data-testid={testId}
    required="true"
    class={cssClass}
>
    <span slot="label">{inputLabel}</span>
</auro-input>

<input type="hidden" name={inputName} bind:value={inputValue} />

<style lang="scss">
    @media screen and (min-width: $ds-grid-breakpoint-md) {
        auro-input {
            width: 30rem;
        }
    }
</style>
